import client from "./client";

const getTransactions = () => client.get("/subsidiary/dashboard/fetch/orders");

export default { getTransactions };
